// 主观题批阅- 查看
import React from 'react';
import { connect } from 'dva';
import { framework_tool, utils_tool, component_tool } from '@/tool'
import ReviewInfo from './components/reviewInfo'
import './index.less'

let { WizContainer, modelUtils } = framework_tool;
let { WizCard, WizRow, WizCol, WizTypography, WizSpin } = component_tool;
let { Session } = utils_tool
let { Text } = WizTypography

class ExaminationLook extends WizContainer {
    componentName = 'examinationLook';

    constructor(props) {
        super(props);
        const { history } = props
        let examinationReviewRecord = {};
        if (history.location && history.location.pathname === '/subjectiveReview/look') {
            examinationReviewRecord = Session.get('examinationReviewRecord') || {}
        }
        this.examinationReviewRecord = examinationReviewRecord
        this.state = {
            dataInfo: []
        }
    }

    propsAndStateOnChange = {
        look: this._getInfoChange.bind(this)
    }

    // 查看
    _getInfoChange(nextProps, nextState) {
        let { look } = nextProps
        let { success, msg, data } = look
        if (success) {
            nextState.dataInfo = data
            return true
        }
        wizNotice.error(msg || '查看批阅信息失败')
        return false
    }

    _componentDidMount() {
        this._getInfo()
    }

    // 获取信息
    _getInfo() {
        let { id, examId, paperId } = this.examinationReviewRecord
        this.doAction({
            path: 'examinationRecord/look',
            payload: {
                key: 'look',
                apiParams: {
                    id,
                    examId,
                    paperId
                }
            },
        })
    }

    _renderHeadCardInfo() {
        let { fullName, orgName, orgCode, positionName } = this.examinationReviewRecord
        return (
            <WizRow gutter={[15, 15]} type='flex' justify='space-around' align='middle'>
                <WizCol span={5}>
                    <Text className='head-text-row'>
                        <span className='head-label-style'>姓名：</span>
                        <span className='head-font-style'>{fullName}</span>
                    </Text>
                </WizCol>
                <WizCol span={5}>
                    <Text className='head-text-row'>
                        <span className='head-label-style'>组织名称：</span>
                        <span className='head-font-style'>{orgName}</span>
                    </Text>
                </WizCol>
                <WizCol span={5}>
                    <Text className='head-text-row'>
                        <span className='head-label-style'>组织代码：</span>
                        <span className='head-font-style'>{orgCode}</span>
                    </Text>
                </WizCol>
                <WizCol span={5}>
                    <Text className='head-text-row'>
                        <span className='head-label-style'>已选岗位：</span>
                        <span className='head-font-style'>{positionName}</span>
                    </Text>
                </WizCol>
            </WizRow>
        )
    }

    _render() {
        let { examinationRecordLoading } = this.props
        let { dataInfo } = this.state
        return (
            <WizSpin spinning={examinationRecordLoading} >
                <div className='review-box'>
                    <WizCard title='学员信息' className={'review-box-base-info'}>
                        {this._renderHeadCardInfo()}
                    </WizCard>
                    <WizCard title='批阅'>
                        <ReviewInfo data={dataInfo} />
                    </WizCard>
                </div>
            </WizSpin>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { examinationRecord } = state
    const look = modelUtils.getModelEntity(examinationRecord, 'look')
    const loading = modelUtils.getLoadingState(state, 'examinationRecord')
    return {
        look,
        ...loading,
    }
};

export default connect(mapStateToProps)(ExaminationLook);
